// src/pages/Island.jsx - Radiant Isle
import React from "react";
import GameMap from "./logic/GameMap";
import { mapConfigs } from "./MapConfig/mapConfigs";

export default function Island() {
  // Set the page title for the Radiant Isle
  React.useEffect(() => {
    document.title = "Radiant Isle | Pokémon Radiance";
  }, []);

  return <GameMap config={mapConfigs.island} />;
}